import { patchRequest } from '@/core';
import { packageTypes } from '@/requests';

export default async function updatePackageTypeRequest(id, patch) {
	let url = packageTypes.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}